<template>
    <div class="min-h-full w-full bg-white">
        <div class="mx-auto w-full max-w-screen-2xl pb-40 px-8" ref="innerbody">
            <div class="flex space-x-2">
                <div class="flex-1">
                    <div class="sticky top-0 bg-white px-0 mb-2 z-30">
                        <!-- Some Tabs. -->
                        <div class="flex flex-1 pt-4">
                            <div class="flex-1">
                                <div
                                    class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0">
                                    Contracted Works
                                </div>

                                <!-- Scope of Works -->
                                <!--
                                <div class="text-sm text-gray-500">
                                    STATUS • Reference #BLAS
                                    <span>• Revision 35</span>
                                </div>
                                -->
                            </div>
                            <div class="pt-3">
                                <div @click="mode='contract'"
                                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                     style="min-width: 20px;cursor: pointer"
                                     :class="mode==='contract'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                >Contract
                                </div>
                                <div @click="mode='variations'"
                                     class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                     style="min-width: 20px;cursor: pointer"
                                     :class="mode==='variations'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                                >Variation Register
                                </div>
                            </div>
                        </div>
                        <div v-if="mode==='contract'">
                            <!-- Listed Contract Sections. -->
                            <div @click="submode='scopeOfWorks'"
                                 class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                 style="min-width: 20px;cursor: pointer"
                                 :class="submode==='scopeOfWorks'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                            >Scope of Works
                            </div>
                            <div @click="submode='preliminaries'"
                                 class="inline-block m-1 border-0 shadow-none px-3 py-2 font-medium text-sm rounded-md focus:z-20 focus:outline-none "
                                 style="min-width: 20px;cursor: pointer"
                                 :class="submode==='preliminaries'?'bg-blue-100 text-blue-700 focus:ring-2 focus:ring-blue-600':''"
                            >Preliminaries
                            </div>
                            <div
                                class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                                <div class="w-6 flex-shrink-0"></div>
                                <div class="w-16 border-l border-r border-gray-200 px-2 py-1">Ref</div>
                                <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                                <div class="w-28 -ml-px border-r border-gray-200 px-2 py-1">Quantity</div>
                                <div class="w-28 -ml-px border-r border-gray-200 px-2 py-1">Value</div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="mode==='contract'" :key="viewKey">
                        <!-- Listed Contract Sections. -->
                        <div v-if="submode==='scopeOfWorks'">
                            <draggable :list="scopeOfWorks" draggable=".draggable" handle=".handle" group="scopeOfWorks"
                                       @change="update">
                                <contracted-works-section v-for="section in scopeOfWorks" :key="section.id"
                                                          :section="section"
                                                          :ref="'scopeOfWorks'"
                                                          :search="search"
                                                          :contracted-works="contractedWorks"
                                                          :latest="currentViewing!=='proposal'?null:latest"
                                                          :readonly="currentViewing!=='proposal'"
                                                          :contract="currentViewing==='proposal'?contractedWorks.proposal:{}"
                                                          @updated="update"
                                                          :currently-building="currentlyBuilding"
                                                          :current-viewing="currentViewing"
                                                          @editBuildup="setBuildup"
                                                          :show-item-progress="showProgress"
                                                          :show-omitted="showOmitted"
                                                          :show-total="showTotal"
                                                          :latest-progress-report="latestProgressReport"
                                                          @deleted="sectionDeleted"
                                ></contracted-works-section>
                            </draggable>
                            <!-- Total Amount. -->
                            <div class="flex text-xs text-gray-500 text-right font-semibold bg-white" v-if="showTotal"
                                 :key="'total'+totalValueKey">
                                <div class="flex-1 px-2 py-1">Contract total</div>
                                <div class="w-20 -ml-px px-2 py-1" v-text="totalValue()">
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2"></div>
                            </div>
                            <div class="py-2" v-else></div>

                            <!-- New Section Item. -->
                            <div class="flex -mb-px bg-white"
                                 v-if="currentViewing==='proposal'">
                                <div class="w-6 flex-shrink-0 self-center">
                                    <i class="fa fa-plus text-xs text-gray-300"></i>
                                </div>
                                <div class="flex-1">
                                    <input
                                        placeholder="Add a new section..."
                                        class="text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                                        type="text"
                                        @input="addNewSectionFromName"
                                        v-model="newSection.name"
                                    >
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                                </div>
                            </div>
                        </div>
                        <div v-else-if="submode==='preliminaries'">
                            <contracted-works-preliminaries
                                :preliminaries="preliminaries"
                                :ref="'preliminaries'"
                                :search="search"
                                :contracted-works="contractedWorks"
                                :latest="currentViewing!=='proposal'?null:latest"
                                :readonly="currentViewing!=='proposal'"
                                :contract="currentViewing==='proposal'?contractedWorks.proposal:{}"
                                @updated="update"
                                :currently-building="currentlyBuilding"
                                :current-viewing="currentViewing"
                                :show-item-progress="showProgress"
                                :show-omitted="showOmitted"
                                :show-total="showTotal"
                                :latest-progress-report="latestProgressReport"
                            ></contracted-works-preliminaries>
                        </div>
                    </div>
                    <div v-else :key="variationViewKey">
                        <div class="bg-blue-50 text-xl py-2 px-3 rounded-t-xl border border-gray-200 flex"
                             :class="!opened['i']?'rounded-b-xl mb-3':''"
                             :ref="'initial'">
                            <span v-text="'Initial Contract'"></span>
                            <div class="flex-grow mt-0 text-lg font-semibold text-right">
                                    <span class="font-semibold mr-2 text-lg"
                                          v-text="toCurrency(resolveNumericText(contractedWorks.initialContract.value,false))"></span>
                                <span
                                    class="text-gray-400 h-6 w-6 -mt-1 pt-1.5 pr-1.5 text-xs border border-gray-200 rounded-lg bg-white hover:bg-blue-50 mx-0.5 fa"
                                    :class="opened['i']?' fa-minus':' fa-plus'"
                                    @click="toggle('i')"
                                ></span>
                            </div>
                        </div>
                        <div class="border-l border-r border-gray-200" v-if="opened['i']">
                            <contracted-works-changes v-for="section in contractedWorks.initialContract.scopeOfWorks"
                                                      :key="section.id"
                                                      :search="search"
                                                      :section="section"
                                                      :contracted-works="contractedWorks"
                                                      :contract="contractedWorks.initialContract"
                                                      :current-viewing="'initial'"
                                                      :currently-building="currentlyBuilding"
                                                      @updated="update"
                                                      @editBuildup="(i) => setBuildup(i,'initial')"
                                                      :readonly="true"
                                                      :show-item-progress="showProgress"
                                                      :show-omitted="true"
                            ></contracted-works-changes>
                            <div class="flex items-center mb-0" v-if="contractedWorks.initialContract.preliminaries.length">
                                <div class="w-6 flex-shrink-0">
                                </div>
                                <div class="flex-grow">
                                    <div
                                        class="whitespace-pre-line text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 resize-none"
                                    >
                                        <div>Preliminaries</div>
                                    </div>
                                </div>
                                <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
                                </div>
                            </div>
                            <contracted-works-task v-for="task in contractedWorks.initialContract.preliminaries"
                                                   :key="task.id"
                                                   :showItemProgress="false"
                                                   :search="search"
                                                   :readonly="true"
                                                   :contracted-works="contractedWorks"
                                                   :show-omitted="showOmitted"
                                                   :section="{id:'Preliminaries'}"
                                                   :latest="latest"
                                                   :currently-building="currentlyBuilding"
                                                   :current-viewing="currentViewing"
                                                   :show-total="false"
                                                   :latest-progress-report="latestProgressReport"
                                                   :task="task" :ref="'tasks'"></contracted-works-task>
                        </div>
                        <div class="bg-blue-50 text-xl py-2 px-3 rounded-b-xl border border-gray-200 mb-3"
                             v-if="opened['i']"></div>
                        <div v-for="(variation) in variationsToCurrentlyViewing" :ref="'variation-'+variation.id">
                            <div class="bg-blue-50 text-xl py-2 px-3 rounded-t-xl border border-gray-200 flex"
                                 :class="!opened[variation.id]?'rounded-b-xl mb-3':''">
                                <span v-text="'Variation ' + variation.variationNumber"></span>
                                <span class="mt-1.5 ml-2 text-sm text-gray-600 font-semibold truncate"
                                      v-text="variation.name"></span>
                                <span class="mt-2 ml-2 text-sm text-gray-600"><i
                                    class="fa fa-info-circle opacity-25 hover:opacity-100" @click="info(variation)"></i></span>
                                <div class="flex-grow mt-0 text-right text-sm align-middle">
                                    <span class="font-semibold mr-2 text-lg"
                                          v-text="toCurrency(resolveNumericText(variation.value))"></span>
                                    (<span class="text-green-600 mx-0.5"
                                           v-if="resolveNumericText(variation.valueOfChange,false)>0">
                                        <i class="fas fa-arrow-up"></i>{{
                                        toCurrency(resolveNumericText(variation.valueOfChange, false))
                                    }}
                                    </span>
                                    <span class="text-red-600 mx-0.5"
                                          v-else-if="resolveNumericText(variation.valueOfChange,false)<0">
                                        <i class="fas fa-arrow-down"></i>{{
                                            toCurrency(resolveNumericText(variation.valueOfChange, false))
                                        }})
                                    </span>
                                    <span class="text-gray-400 mx-0.5" v-else>no change</span>)
                                    <span
                                        class="text-gray-400 h-6 w-6 -mt-1 pt-1.5 pr-1.5 text-xs border border-gray-200 rounded-lg bg-white hover:bg-blue-50 mx-0.5 fa"
                                        :class="opened[variation.id]?' fa-minus':' fa-plus'"
                                        @click="toggle(variation.id)"
                                    ></span>
                                </div>
                            </div>
                            <contracted-works-operations :operations="variation.operations"
                                                         v-if="opened[variation.id]"
                                                         :search="search"
                                                         :show-item-progress="showProgress"
                                                         @editBuildup="(i) => setBuildup(i,variation.id)"
                                                         :currently-building="currentlyBuilding"
                                                         :current-viewing="variation.id"
                                                         :contract="variation.previousContractState"></contracted-works-operations>
                            <div class="bg-blue-50 text-xl py-2 px-6 rounded-b-xl mb-3 border border-gray-200"
                                 v-if="opened[variation.id]"></div>
                        </div>
                    </div>
                </div>
                <div class="w-72 space-y-8 relative pt-4">
                    <div class="w-72 space-y-1 fixed">
                        <contracted-works-action-panel :user="user"
                                                       :contracted-works="contractedWorks"
                                                       :editing="currentViewing === 'proposal'"
                                                       :scopeOfWorks="scopeOfWorks"
                                                       @reflow="reflow"
                                                       @reset="reset"
                                                       @importEstimate="importEstimate"></contracted-works-action-panel>
                        <div
                            style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; height:calc(100vh - 250px)">
                            <div class="space-y-1 top-1">
                                <div class="flex w-full ">
                                    <label class="mt-1 text-gray-700 align-baseline font-medium flex-1 flex-grow">Show
                                        Latest Progress Report</label>
                                    <ui-toggle v-model="showProgress"
                                               class="inline-block w-auto flex p-0.5 rounded-xl"></ui-toggle>
                                </div>
                                <div class="flex w-full ">
                                    <label class="mt-1 text-gray-700 align-baseline font-medium flex-1 flex-grow">Show
                                        Omitted Items</label>
                                    <ui-toggle v-model="showOmitted"
                                               class="inline-block w-auto flex p-0.5 rounded-xl"></ui-toggle>
                                </div>
                            </div>
                            <h2 class="text-base font-medium text-gray-700 mt-2 text-center">Search</h2>
                            <div class="relative mt-0.5">
                                <ui-input field="bg-gray-50 pr-10 mx-1 focus:ring-blue-600 focus:border-blue-600"
                                          name="search" v-model="search"></ui-input>
                                <div
                                    class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                                    <i class="fas fa-search"></i>
                                </div>
                            </div>
                            <contracted-works-timeline-panel class="mt-4"
                                                             :contractedWorks="contractedWorks"
                                                             :currentViewing="currentViewing"
                                                             @variationSelected="variationSelected"
                                                             @initialContractSelected="initialContractSelected"
                                                             @proposalSelected="proposalSelected"
                                                             @proposalCleared="proposalCleared"
                                                             @proposalAccept="proposalAccept"
                            ></contracted-works-timeline-panel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ContractedWorksItem from "./ContractedWorksItem.vue";
import ContractedWorksTask from "./ContractedWorksTask.vue";
import ContractedWorksActionPanel from "./ContractedWorksActionPanel.vue";
import UiToggle from "../../ui/UiToggle.vue";
import ContractedWorksTimelinePanel from "./ContractedWorksTimelinePanel.vue";
import ContractedWorksSection from "./ContractedWorksSection.vue";
import draggable from 'vuedraggable'
import {ContractedWorks, ProgressReport} from "@models";
import {cloneDeep, debounce} from "lodash";
import ContractedWorksOperations from "./ContractedWorksOperations.vue";
import {resolveNumericText, toCurrency, uuid} from "../../../utils"
import * as math from "mathjs";
import moment from "moment";
import ContractedWorksChanges from "./ContractedWorksChanges.vue";
import ContractedWorksPreliminaries from "./ContractedWorksPreliminaries.vue";

export default {
    components: {
        ContractedWorksPreliminaries,
        ContractedWorksChanges,
        ContractedWorksOperations,
        ContractedWorksSection,
        draggable,
        ContractedWorksTimelinePanel, UiToggle, ContractedWorksActionPanel, ContractedWorksTask, ContractedWorksItem
    },
    props: {
        id: String,
        packageReference: String,
    },
    data() {
        return {
            opened: [],
            newSection: {name: ''},
            contractedWorks: null,
            scopeOfWorks: [],
            preliminaries: [],
            search: '',
            user: {},
            viewKey: '',
            updateKey: 0,
            showProgress: false,
            showOmitted: false,
            showTotal: true,
            currentViewing: 'initial',
            latest: null,
            mode: 'contract',
            submode: 'scopeOfWorks',
            updateDebounced: debounce(this.updateNow, 200, {leading: true, maxWait: 1000}),
            currentlyBuilding: {currentViewing: 'initial', id: false},
            resolveNumericText,
            totalValueKey: 0,
            variationViewKey: 0,
            latestProgressReport: Object,
        }
    },
    computed: {
        moment() {
            return moment
        },
        variationsToCurrentlyViewing() {
            // just show ALL of them
            let ret = this.contractedWorks.variations.slice();
            let previous = this.contractedWorks.initialContract;
            ret.forEach((i) => {
                i.previousContractState = previous
                previous = i;
            })
            return ret;
        }
    },
    methods: {
        toggle(id) {
            this.opened[id] = !this.opened[id];
            this.variationViewKey++;
        },
        sectionDeleted() {
            this.proposalSelected();
        },
        info(variation) {
            this.$modals.open('contracted-works-acceptance-info', {
                title: 'Acceptance Data',
                variation: variation,
            })
        },
        toCurrency,
        totalValue() {
            let value = 0;
            this.scopeOfWorks.forEach((section) => {
                section.tasks.forEach((task) => {
                    task.items.forEach((i) => {
                        if ((i.status === 'OMITTED') || (i.proposedStatus === 'OMITTED')) {
                        } else {
                            value += parseFloat(i.value ? (i.value.replace(/[^\d.-]/g, '')) : 0);
                        }
                    })
                })
            })
            return toCurrency(value)
        },
        setBuildup(i, currentViewing = false) {
            if (!currentViewing) {
                currentViewing = this.currentViewing
            }
            if (this.currentlyBuilding.id === i.id && this.currentlyBuilding.currentViewing === currentViewing) {
                this.currentlyBuilding = {currentViewing: currentViewing, id: false}
            } else {
                this.currentlyBuilding = {currentViewing: currentViewing, id: i.id}
            }
        },
        addNewSectionFromName() {
            this.scopeOfWorks.push({
                id: uuid(),
                name: this.newSection.name,
                tasks: [],
                proposedStatus: 'ADDED',
            })
            this.$nextTick(() => {
                this.$refs.scopeOfWorks.at(-1).update()
                this.newSection = {name: null}
                this.$refs.scopeOfWorks.at(-1).$refs.sectionName.focus()
            })

        },
        update(snapshot) {
            if (this.contractedWorks) {
                if (this.contractedWorks.getProposal()) {
                    this.contractedWorks.getProposal().scopeOfWorks = this.scopeOfWorks;
                    this.contractedWorks.getProposal().preliminaries = this.preliminaries;
                }
                if (snapshot) {
                    this.contractedWorks.addSnapshot()
                }
            }
            this.updateDebounced()
        },
        updateNow() {
            this.contractedWorks.updateProposal({
                'scopeOfWorks': this.scopeOfWorks,
                'preliminaries': this.preliminaries,
            })
        },
        variationSelected(vId) {
            this.viewKey = vId
            this.currentViewing = vId
            this.scopeOfWorks = this.contractedWorks.variations.find((i) => i.id === vId).scopeOfWorks
            this.preliminaries = this.contractedWorks.variations.find((i) => i.id === vId).preliminaries
            this.$nextTick(() => {
                if ((this.mode !== 'contract') && (this.$refs['variation-' + vId])[0]) {
                    this.$refs['variation-' + vId][0].scrollIntoView({block: "center", inline: "nearest"});
                }
            })
        },
        initialContractSelected() {
            this.viewKey = this.updateKey++
            this.currentViewing = 'initial'
            this.scopeOfWorks = this.contractedWorks.initialContract.scopeOfWorks
            this.preliminaries = this.contractedWorks.initialContract.preliminaries
            this.$nextTick(() => {
                if ((this.mode !== 'contract') && (this.$refs['initial'])) {
                    this.$refs['initial'].scrollIntoView({block: "center", inline: "nearest"});
                }
            })
        },
        async proposalSelected() {
            this.currentViewing = 'proposal'
            this.mode = 'contract'

            if (this.contractedWorks.variations.length) {
                this.latest = this.contractedWorks.variations.at(-1)
            } else if (this.contractedWorks.initialContract) {
                this.latest = this.contractedWorks.initialContract
            } else {
                this.latest = null
            }

            if (this.contractedWorks.proposal) {
                this.scopeOfWorks = this.contractedWorks.proposal.scopeOfWorks
                this.preliminaries = this.contractedWorks.proposal.preliminaries
            } else if (this.contractedWorks.variations.length) {
                this.scopeOfWorks = cloneDeep(this.contractedWorks.variations.at(-1).scopeOfWorks);
                this.preliminaries = cloneDeep(this.contractedWorks.variations.at(-1).preliminaries);
            } else if (this.contractedWorks.initialContract) {
                this.scopeOfWorks = cloneDeep(this.contractedWorks.initialContract.scopeOfWorks);
                this.preliminaries = cloneDeep(this.contractedWorks.initialContract.preliminaries);
            } else {
                this.scopeOfWorks = [];
                this.preliminaries = [];
            }
            this.viewKey = this.updateKey++
        },
        async proposalAccept() {
            this.$modals.open('contracted-works-accept-proposal', {
                title: 'Accept Proposal as a new Variation',
                name: '',
                handle: async (name, comments) => {
                    await this.contractedWorks.acceptProposal(name, comments);
                    await this.updateLatest()
                }
            })
        },
        async proposalCleared() {
            await this.contractedWorks.clearProposal();
            await this.updateLatest()
        },
        async updateLatest() {
            this.latestProgressReport = await ProgressReport.latest(this.packageReference);
            this.contractedWorks = await ContractedWorks.find(this.packageReference);
            if (this.contractedWorks.variations.length) {
                this.latest = this.contractedWorks.variations.at(-1)
            } else if (this.contractedWorks.initialContract) {
                this.latest = this.contractedWorks.initialContract
            } else {
                this.latest = null
            }
            if (this.contractedWorks.variations.length) {
                this.variationSelected(this.contractedWorks.variations.at(-1).id)
            } else if (this.contractedWorks.initialContract) {
                this.initialContractSelected()
            } else {
                this.proposalSelected()
            }
        },
        async reflow() {
            this.scopeOfWorks = this.contractedWorks.proposal.scopeOfWorks
            this.preliminaries = this.contractedWorks.proposal.preliminaries
            this.$nextTick(() => {
                this.viewKey = this.updateKey++
            })
        },
        async reset() {
            await ContractedWorks.reset(this.packageReference);
            document.location.reload()
        },
        importEstimate() {
            this.$modals.open('contracted-works-import-from-estimate', {
                packageReference: this.packageReference,
                handle: async (estimate, modal) => {
                    estimate.scopeOfWorks.forEach((eSection, iSection) => {
                        this.scopeOfWorks.push({
                            id: uuid(),
                            proposedStatus: 'ADDED',
                            name: eSection.title,
                            tasks: eSection.tasks.map((eTask, iTask) => {
                                return {
                                    id: uuid(),
                                    proposedStatus: 'ADDED',
                                    reference: eTask.reference,
                                    name: eTask.name,
                                    items: eTask.items.map((eItem, iItem) => {
                                        let materials = []
                                        let labour = []
                                        let fixedCosts = []
                                        let buildup = []
                                        if (eItem.bundle) {
                                            eItem.bundle.forEach((i) => {
                                                materials.push(...i.materials.map((m) => ({
                                                    'name': m.name,
                                                    'uom': m.uom,
                                                    'quantity': Math.round(m.quantity * 100) / 100,
                                                    'value': toCurrency(m.total),
                                                    'component': m.component ? m.component : null,
                                                })))
                                                labour.push(...i.labour.map((m) => ({
                                                    'name': m.name,
                                                    'value': toCurrency(m.total),
                                                    'component': m.component ? m.component : null,
                                                })))
                                                fixedCosts.push(...i.fixedCosts.map((m) => ({
                                                    'name': m.name,
                                                    'quantity': (Math.round(m.quantity * 100) / 100) + (m.unit ? (' ' + m.unit) : ''),
                                                    'value': toCurrency(m.total),
                                                    'component': m.component ? m.component : null,
                                                })))
                                            })
                                        } else {
                                            materials.push(...eItem.materials.map((m) => ({
                                                'name': m.name,
                                                'uom': m.uom,
                                                'quantity': Math.round(m.quantity * 100) / 100,
                                                'value': toCurrency(m.total),
                                                'component': m.component ? m.component : null,
                                            })))
                                            labour.push(...eItem.labour.map((m) => ({
                                                'name': m.name,
                                                'value': toCurrency(m.total),
                                                'component': m.component ? m.component : null,
                                            })))
                                            fixedCosts.push(...eItem.fixedCosts.map((m) => ({
                                                'name': m.description,
                                                'quantity': (Math.round(m.quantity * 100) / 100) + (m.unit ? (' ' + m.unit) : ''),
                                                'value': toCurrency(m.total),
                                                'component': m.component ? m.component : null,
                                            })))
                                        }
                                        let total = 0
                                        materials.concat(labour, fixedCosts).forEach((m) => {
                                            let value = math.round(this.resolveNumericText(m.value), 2);
                                            total = math.round(total + value, 2);
                                            if (String((m.component ? m.component : '')).trim() !== '') {
                                                let component = buildup.find((i) => i.name.trim() === m.component.trim())
                                                if (component) {
                                                    component.value = math.round(component.value + value, 2)
                                                } else {
                                                    component = {
                                                        name: m.component.trim(),
                                                        value: math.round(value, 2),
                                                        id: uuid()
                                                    }
                                                    buildup.push(component)
                                                }
                                                m.component = component
                                                m.componentId = component.id
                                            } else {
                                                delete m.component
                                            }
                                        })
                                        buildup.forEach((i) => {
                                            i.ratio = total ? (i.value / total) : 0
                                            i.percent = math.floor(i.ratio * 100, 0) + '%'
                                        })
                                        return {
                                            id: uuid(),
                                            proposedStatus: 'ADDED',
                                            reference: eItem.reference,
                                            description: eItem.description,
                                            quantity: eItem.quantity + ' ' + eItem.uom,
                                            value: toCurrency(eItem.total),
                                            importedComponentBuildup: {
                                                source: {
                                                    estimate: {
                                                        id: estimate.id,
                                                        name: estimate.title,
                                                        reference: estimate.reference
                                                    },
                                                    section: {
                                                        index: iSection,
                                                        name: eSection.title
                                                    },
                                                    task: {
                                                        index: iTask,
                                                        name: eTask.name,
                                                        reference: eTask.reference
                                                    },
                                                    item: {
                                                        index: iItem,
                                                        name: eItem.description,
                                                        reference: eItem.reference
                                                    },
                                                },
                                                components: buildup,
                                                materials: materials,
                                                labour: labour,
                                                fixedCosts: fixedCosts,
                                            }
                                        }
                                    })
                                }
                            }),
                        })
                    })
                    estimate.preliminaries.forEach((eTask, iTask) => {
                        this.preliminaries.push({
                            id: uuid(),
                            proposedStatus: 'ADDED',
                            reference: eTask.reference,
                            name: eTask.name,
                            items: eTask.items.map((eItem, iItem) => {
                                return {
                                    id: uuid(),
                                    proposedStatus: 'ADDED',
                                    reference: eItem.reference,
                                    description: eItem.description,
                                    quantity: eItem.quantity + ' ' + eItem.uom,
                                    value: toCurrency(eItem.total),
                                    importedComponentBuildup: {
                                        source: {
                                            estimate: {
                                                id: estimate.id,
                                                name: estimate.title,
                                                reference: estimate.reference
                                            },
                                            section: {
                                                index: -1,
                                                name: 'Preliminaries',
                                            },
                                            task: {
                                                index: iTask,
                                                name: eTask.name,
                                                reference: eTask.reference
                                            },
                                            item: {
                                                index: iItem,
                                                name: eItem.description,
                                                reference: eItem.reference
                                            },
                                        },
                                    }
                                }
                            })
                        });
                    })
                    this.$nextTick(() => {
                        this.update(true);
                    })
                    modal.close()
                }
            })
        }
    },
    async mounted() {
        await this.updateLatest()
        $('#app-content').css('padding', 0);
    },
}
</script>
